import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ConfirmationCommentsForCustomerModel } from '@evorait/pace-core';
import { FormArray } from '@angular/forms';

@Component({
    selector: 'pace-confirmation-comments-for-customer',
    templateUrl: './confirmation-comments-for-customer.component.html',
    styleUrls: ['./confirmation-comments-for-customer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationCommentsForCustomerComponent {
    @Input()
    public model: ConfirmationCommentsForCustomerModel;

    @Input()
    public parentForm: FormArray;
}
